<template>
  <div class="adm-dash">

    <!-- Header -->
    <div class="adm-header">
      <div>
        <h2 class="adm-title">Dashboard de Clientes</h2>
        <p class="adm-sub">Métricas de cadastro, conversão e churn</p>
      </div>
      <button class="adm-refresh" @click="load" :disabled="loading">
        <feather-icon icon="RefreshCwIcon" size="14" :class="{ spinning: loading }" />
        Atualizar
      </button>
    </div>

    <div v-if="loading" class="adm-loading">
      <div class="adm-spinner" />
      Carregando...
    </div>

    <template v-else>

      <!-- KPIs principais -->
      <div class="adm-kpis">
        <div class="adm-kpi">
          <div class="adm-kpi__icon" style="background:rgba(232,106,16,0.1);color:#E86A10">
            <feather-icon icon="UsersIcon" size="18" />
          </div>
          <div class="adm-kpi__val">{{ d.resumo.total }}</div>
          <div class="adm-kpi__label">Total clientes</div>
        </div>
        <div class="adm-kpi">
          <div class="adm-kpi__icon" style="background:rgba(16,185,129,0.1);color:#10B981">
            <feather-icon icon="UserCheckIcon" size="18" />
          </div>
          <div class="adm-kpi__val">{{ d.resumo.ativos }}</div>
          <div class="adm-kpi__label">Ativos</div>
        </div>
        <div class="adm-kpi">
          <div class="adm-kpi__icon" style="background:rgba(59,130,246,0.1);color:#3B82F6">
            <feather-icon icon="CreditCardIcon" size="18" />
          </div>
          <div class="adm-kpi__val">{{ d.resumo.pagantes }}</div>
          <div class="adm-kpi__label">Pagantes</div>
        </div>
        <div class="adm-kpi">
          <div class="adm-kpi__icon" style="background:rgba(245,185,53,0.1);color:#F5B935">
            <feather-icon icon="GiftIcon" size="18" />
          </div>
          <div class="adm-kpi__val">{{ d.resumo.gratis }}</div>
          <div class="adm-kpi__label">Grátis / Trial</div>
        </div>
        <div class="adm-kpi">
          <div class="adm-kpi__icon" style="background:rgba(239,68,68,0.1);color:#EF4444">
            <feather-icon icon="UserXIcon" size="18" />
          </div>
          <div class="adm-kpi__val">{{ d.resumo.churn }}</div>
          <div class="adm-kpi__label">Churn (30d)</div>
        </div>
        <div class="adm-kpi">
          <div class="adm-kpi__icon" style="background:rgba(139,92,246,0.1);color:#8B5CF6">
            <feather-icon icon="TrendingUpIcon" size="18" />
          </div>
          <div class="adm-kpi__val">{{ d.conversao.taxa }}</div>
          <div class="adm-kpi__label">Conversão trial</div>
        </div>
      </div>

      <!-- Cadastros por período -->
      <div class="adm-card">
        <h3 class="adm-card__title">
          <feather-icon icon="CalendarIcon" size="14" class="mr-50" />
          Cadastros por Período
        </h3>
        <div class="adm-periods">
          <div v-for="p in periods" :key="p.key" class="adm-period" :class="{ 'adm-period--active': selectedPeriod === p.key }" @click="selectedPeriod = p.key">
            <div class="adm-period__val">{{ d.periodos[p.key] }}</div>
            <div class="adm-period__label">{{ p.label }}</div>
          </div>
        </div>
      </div>

      <!-- Conversão -->
      <div class="adm-row">
        <div class="adm-card adm-card--half">
          <h3 class="adm-card__title">
            <feather-icon icon="RepeatIcon" size="14" class="mr-50" />
            Funil de Conversão (60d)
          </h3>
          <div class="adm-funnel">
            <div class="adm-funnel__item">
              <div class="adm-funnel__bar" :style="{ width: '100%', background: '#E86A10' }"></div>
              <span>{{ d.conversao.total_trials }} trials</span>
            </div>
            <div class="adm-funnel__item">
              <div class="adm-funnel__bar" :style="{ width: convWidth + '%', background: '#10B981' }"></div>
              <span>{{ d.conversao.convertidos }} pagantes ({{ d.conversao.taxa }})</span>
            </div>
          </div>
        </div>
        <div class="adm-card adm-card--half">
          <h3 class="adm-card__title">
            <feather-icon icon="PieChartIcon" size="14" class="mr-50" />
            Segmentação
          </h3>
          <div class="adm-seg-grid">
            <div class="adm-seg">
              <div class="adm-seg__dot" style="background:#10B981"></div>
              <span>Pagantes</span>
              <strong>{{ d.resumo.pagantes }}</strong>
            </div>
            <div class="adm-seg">
              <div class="adm-seg__dot" style="background:#F5B935"></div>
              <span>Grátis</span>
              <strong>{{ d.resumo.gratis }}</strong>
            </div>
            <div class="adm-seg">
              <div class="adm-seg__dot" style="background:#3B82F6"></div>
              <span>Ativos</span>
              <strong>{{ d.resumo.ativos }}</strong>
            </div>
            <div class="adm-seg">
              <div class="adm-seg__dot" style="background:#EF4444"></div>
              <span>Inativos</span>
              <strong>{{ d.resumo.inativos }}</strong>
            </div>
            <div class="adm-seg">
              <div class="adm-seg__dot" style="background:#8B5CF6"></div>
              <span>Convertidos</span>
              <strong>{{ d.conversao.convertidos }}</strong>
            </div>
            <div class="adm-seg">
              <div class="adm-seg__dot" style="background:#EF4444"></div>
              <span>Churn (30d)</span>
              <strong>{{ d.resumo.churn }}</strong>
            </div>
          </div>
        </div>
      </div>

      <!-- Mini gráfico de cadastros diários -->
      <div class="adm-card">
        <h3 class="adm-card__title">
          <feather-icon icon="BarChart2Icon" size="14" class="mr-50" />
          Período (dia/mês)
        </h3>
        <div class="adm-chart">
          <div v-for="(day, i) in d.grafico" :key="i" class="adm-chart__bar-wrap" :title="formatDay(day.dia) + ': ' + day.qtd + ' leads'">
            <div class="adm-chart__val" :class="{ 'adm-chart__val--hidden': !showDayLabel(i) }">{{ day.qtd }}</div>
            <div class="adm-chart__bar" :style="{ height: barHeight(day.qtd) + '%' }"></div>
            <div class="adm-chart__day" :class="{ 'adm-chart__day--hidden': !showDayLabel(i) }">{{ formatDay(day.dia) }}</div>
          </div>
        </div>
      </div>

    </template>
  </div>
</template>

<script>
import { useApi } from '@/composables/useApi'
const api = useApi()

export default {
  name: 'AdminDashboard',
  data() {
    return {
      loading: true,
      selectedPeriod: 'ultimos_7d',
      d: {
        resumo: { total: 0, ativos: 0, inativos: 0, pagantes: 0, gratis: 0, churn: 0 },
        periodos: {},
        conversao: { total_trials: 0, convertidos: 0, taxa: '0%' },
        grafico: [],
      },
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
      periods: [
        { key: 'hoje', label: 'Hoje' },
        { key: 'ontem', label: 'Ontem' },
        { key: 'ultimos_7d', label: '7 dias' },
        { key: 'ultimos_15d', label: '15 dias' },
        { key: 'ultimos_30d', label: '30 dias' },
        { key: 'mes_atual', label: 'Mês atual' },
        { key: 'mes_passado', label: 'Mês passado' },
        { key: 'todo_periodo', label: 'Todo período' },
      ],
    }
  },
  computed: {
    convWidth() {
      if (!this.d.conversao.total_trials) return 0
      return Math.max(5, (this.d.conversao.convertidos / this.d.conversao.total_trials) * 100)
    },
    maxDailySignups() {
      return Math.max(1, ...this.d.grafico.map(g => g.qtd))
    },
    chartLabelStep() {
      const total = this.d.grafico.length || 1
      const maxLabels = this.viewportWidth <= 600 ? 5 : this.viewportWidth <= 900 ? 8 : 12
      return Math.max(1, Math.ceil(total / maxLabels))
    },
  },
  mounted() {
    this.load()
    this._onResize = () => { this.viewportWidth = window.innerWidth }
    window.addEventListener('resize', this._onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onResize)
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const { data } = await api.get('/usuarios/dashboard')
        this.d = data
      } catch (e) {
        console.error('Dashboard error:', e)
      }
      this.loading = false
    },
    barHeight(qtd) {
      return Math.max(4, (qtd / this.maxDailySignups) * 100)
    },
    formatDay(d) {
      if (!d) return ''
      const dt = new Date(d)
      if (!Number.isNaN(dt.getTime())) {
        const day = String(dt.getDate()).padStart(2, '0')
        const month = String(dt.getMonth() + 1).padStart(2, '0')
        return `${day}/${month}`
      }
      const iso = String(d).split('T')[0]
      const parts = iso.split('-')
      if (parts.length >= 3) return `${parts[2]}/${parts[1]}`
      return String(d)
    },
    showDayLabel(index) {
      const last = this.d.grafico.length - 1
      return index === last || index % this.chartLabelStep === 0
    },
  },
}
</script>

<style scoped>
.adm-dash { max-width: 1100px; margin: 0 auto; padding: 8px 16px 40px; box-sizing: border-box; }
.adm-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.adm-title { font-size: 20px; font-weight: 800; color: #e2e8f0; margin: 0; }
.adm-sub { font-size: 12px; color: rgba(255,255,255,0.4); margin: 4px 0 0; }
.adm-refresh {
  display: flex; align-items: center; gap: 6px; padding: 8px 16px;
  border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.06);
  font-size: 13px; font-weight: 600; color: #cbd5e1; cursor: pointer;
  transition: all 0.15s;
}
.adm-refresh:hover { border-color: #E86A10; color: #E86A10; }
.spinning { animation: spin 1s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

.adm-loading { display: flex; align-items: center; gap: 12px; justify-content: center; padding: 60px 0; color: rgba(255,255,255,0.4); font-size: 14px; }
.adm-spinner { width: 20px; height: 20px; border-radius: 50%; border: 2px solid rgba(255,255,255,0.1); border-top-color: #E86A10; animation: spin 0.8s linear infinite; }

/* KPIs */
.adm-kpis { display: grid; grid-template-columns: repeat(6, minmax(120px, 1fr)); gap: 12px; margin-bottom: 16px; }
.adm-kpi {
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px;
  padding: 16px; text-align: center;
  transition: all 0.2s;
}
.adm-kpi:hover { background: rgba(255,255,255,0.07); transform: translateY(-2px); }
.adm-kpi__icon { width: 36px; height: 36px; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin: 0 auto 10px; }
.adm-kpi__val { font-size: 24px; font-weight: 800; color: #e2e8f0; letter-spacing: -0.5px; }
.adm-kpi__label { font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.4); text-transform: uppercase; letter-spacing: 0.3px; margin-top: 4px; }

/* Cards */
.adm-card {
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px;
  padding: 20px; margin-bottom: 16px;
  min-width: 0;
}
.adm-card__title { font-size: 13px; font-weight: 700; color: #e2e8f0; margin: 0 0 16px; display: flex; align-items: center; }
.adm-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.adm-card--half { margin-bottom: 0; }

/* Periods */
.adm-periods { display: grid; grid-template-columns: repeat(8, minmax(90px, 1fr)); gap: 8px; }
.adm-period {
  text-align: center; padding: 14px 8px; border-radius: 10px;
  background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.08); cursor: pointer;
  transition: all 0.2s;
}
.adm-period:hover { border-color: rgba(232,106,16,0.5); }
.adm-period--active { border-color: #E86A10; background: rgba(232,106,16,0.1); }
.adm-period__val { font-size: 22px; font-weight: 800; color: #e2e8f0; }
.adm-period--active .adm-period__val { color: #E86A10; }
.adm-period__label { font-size: 10px; font-weight: 600; color: rgba(255,255,255,0.4); text-transform: uppercase; margin-top: 4px; }

/* Funnel */
.adm-funnel { display: flex; flex-direction: column; gap: 10px; }
.adm-funnel__item { display: flex; align-items: center; gap: 12px; }
.adm-funnel__bar { height: 28px; border-radius: 6px; min-width: 20px; transition: width 0.5s; }
.adm-funnel__item span { font-size: 13px; font-weight: 600; color: #cbd5e1; white-space: nowrap; }

/* Segmentation */
.adm-seg-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.adm-seg { display: flex; align-items: center; gap: 8px; font-size: 13px; color: rgba(255,255,255,0.6); }
.adm-seg__dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.adm-seg strong { margin-left: auto; font-weight: 800; color: #e2e8f0; }

/* Chart */
.adm-chart { display: flex; align-items: flex-end; gap: 3px; height: 120px; padding: 8px 0 16px; }
.adm-chart__bar-wrap { flex: 1; display: flex; flex-direction: column; align-items: center; height: 100%; justify-content: flex-end; cursor: pointer; }
.adm-chart__val { font-size: 9px; color: rgba(255,255,255,0.55); margin-bottom: 3px; line-height: 1; min-height: 10px; }
.adm-chart__val--hidden { opacity: 0; }
.adm-chart__bar { width: 100%; min-height: 3px; background: #E86A10; border-radius: 3px 3px 0 0; transition: height 0.3s; opacity: 0.5; }
.adm-chart__bar-wrap:hover .adm-chart__bar { opacity: 1; }
.adm-chart__day { font-size: 8px; color: rgba(255,255,255,0.38); margin-top: 4px; white-space: nowrap; line-height: 1; min-height: 10px; }
.adm-chart__day--hidden { opacity: 0; }

@media (max-width: 900px) {
  .adm-dash { padding: 8px 12px 28px; }
  .adm-header { align-items: flex-start; gap: 10px; }
  .adm-refresh { padding: 7px 12px; font-size: 12px; }
  .adm-kpi__val { font-size: 20px; }
  .adm-kpis { grid-template-columns: repeat(3, 1fr); }
  .adm-periods { grid-template-columns: repeat(4, 1fr); }
  .adm-row { grid-template-columns: 1fr; }
  .adm-card { padding: 16px; }
  .adm-chart { height: 110px; }
}
@media (max-width: 600px) {
  .adm-dash { padding: 6px 10px 22px; }
  .adm-header { flex-direction: column; align-items: stretch; }
  .adm-refresh { width: 100%; justify-content: center; }
  .adm-title { font-size: 18px; }
  .adm-sub { font-size: 11px; }
  .adm-kpis { grid-template-columns: repeat(2, 1fr); }
  .adm-periods { grid-template-columns: repeat(2, 1fr); }
  .adm-period__val { font-size: 19px; }
  .adm-funnel__item { flex-direction: column; align-items: flex-start; gap: 6px; }
  .adm-funnel__bar { width: 100% !important; }
  .adm-funnel__item span { white-space: normal; font-size: 12px; }
  .adm-seg-grid { grid-template-columns: 1fr; }
  .adm-chart { overflow-x: auto; gap: 6px; padding-bottom: 2px; }
  .adm-chart__bar-wrap { min-width: 22px; }
  .adm-chart__day { font-size: 8px; }
}
</style>
